const EDGE_UA_REGEXP = /(edge)[\s\/:]([\w\d\.]+)/;
const UA_REGEXP = new RegExp('(opera|ie|firefox|chrome|trident|crios|version)' +
    '[\\s/:]([\\w\\d\\.]+)?.*?(safari|(?:rv[\\s\\/:]|version[\\s\\/:])' +
    '([\\w\\d\\.]+)|$)');
/**
 * Used for caching parsed user agents to avoid multiple parsing.
 */
const cache = {};
/**
 * Parse the userAgent and platformStr and return a deviceInfo structure.
 *
 * @param  userAgent - String like navigator.userAgent
 * @param  platformStr - String like navigator.platform
 * @return NavigatorInfo structure with name, version and platform.
 */
export function parseUA(userAgent, platformStr) {
    const ua = userAgent.toLowerCase();
    let platform = platformStr ? platformStr.toLowerCase() : '';
    const cacheKey = `${ua}:${platform}`;
    if (cacheKey in cache) {
        return cache[cacheKey];
    }
    const EDGE_UA = ua.match(EDGE_UA_REGEXP);
    const COMMON_UA = ua.match(UA_REGEXP) || [null, 'unknown', 0];
    // chrome is included in the edge UA, so need to check for edge first,
    // before checking if it's chrome.
    const UA = EDGE_UA || COMMON_UA;
    if (UA[1] === 'trident') {
        UA[1] = 'ie';
        if (UA[4])
            UA[2] = UA[4];
    }
    else if (UA[1] === 'crios') {
        UA[1] = 'chrome';
    }
    platform = ua.match(/ip(?:ad|od|hone)/)
        ? 'ios'
        : (ua.match(/(?:webos|android)/) ||
            ua.match(/mac|win|linux|cros/) || ['other'])[0];
    if (platform === 'win') {
        platform = 'windows';
    }
    const _name = UA[1] === 'version' ? UA[3] : UA[1];
    const _version = UA[1] === 'opera' && UA[4] ? UA[4] : UA[2];
    const parsed = {
        name: _name ? _name.toString() : 'unknown',
        version: _version === null ? 'unknown' : _version.toString(),
        platform,
    };
    cache[cacheKey] = parsed;
    return parsed;
}
//# sourceMappingURL=parse_ua.js.map